module.exports = __webpack_public_path__ + "static/img/complianceSystes1.f9910c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home/complianceSystes1.png
// module id = BTba
// module chunks = 1